import { render, staticRenderFns } from "./Bof.vue?vue&type=template&id=5c092c6a&scoped=true&"
import script from "./Bof.vue?vue&type=script&lang=js&"
export * from "./Bof.vue?vue&type=script&lang=js&"
import style0 from "./Bof.vue?vue&type=style&index=0&id=5c092c6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c092c6a",
  null
  
)

export default component.exports